module.exports = __webpack_public_path__ + "static/media/social_ig_gray.f0a2db19.svg";